import React, { Component } from 'react';
import { IFilterProps } from 'types/frontend_models/table/IFilterProps';

interface IProps extends IFilterProps
{
	placeHolder?: string | undefined,
	defaultValue?: string | string[] | number
	/** Defines how much time (in ms) has to pass, before the setFilter event is fired. */
	filterDelay: number
}

/** Input element used to filter table data */
class TableInputFilter extends Component<IProps> {
	private _timeOut: NodeJS.Timeout | null = null;

	constructor(props: IProps)
	{
		super(props);
		this.onValueChanged = this.onValueChanged.bind(this);
	}

	onValueChanged(event: React.ChangeEvent<HTMLInputElement>)
	{
		// For debugging
		// console.log(this);
		// console.log(event);

		if (this._timeOut !== null) {
			clearTimeout(this._timeOut);
		}

		// Store target value here, because it event data will be nullified by React in timeout callback
		// Read: https://reactjs.org/docs/events.html#event-pooling
		const targetValue = event.target.value;

		this._timeOut = setTimeout(() =>
		{

			this.props.setFilter(
				this.props.column.id as string, targetValue || undefined
			);
			this._timeOut = null;
		}, this.props.filterDelay);
	}

	render()
	{
		const props = this.props;
		const placeHolder = props.placeHolder ? props.placeHolder : 'Search...';

		return <input
			className="naked-input"
			placeholder={placeHolder}
			defaultValue={props.defaultValue}
			onChange={this.onValueChanged}
		/>;
	}
}

export default TableInputFilter;